import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { Spinner } from "@heroui/react";
import useAuth from "@/lib/auth/useAuth";

export const Route = createFileRoute("/dashboard/csp-portal/")({
    component: CspPortal,
});

function CspPortal() {
    const navigate = useNavigate();
    const { user, isConsultant, isFetched } = useAuth();
    const organization =
        user?.organization && typeof user.organization === "object"
            ? user.organization
            : undefined;
    const eligible =
        isConsultant && organization?.group_type === "service provider";
    const ownOrganizationId = eligible ? String(organization.id) : undefined;

    useEffect(() => {
        if (!isFetched) return;
        if (!ownOrganizationId) {
            navigate({ to: "/dashboard/home", replace: true });
        } else {
            navigate({
                to: "/dashboard/csp-portal/$organizationId/resources",
                params: { organizationId: ownOrganizationId },
                replace: true,
            });
        }
    }, [isFetched, navigate, ownOrganizationId]);

    return (
        <div className="flex h-full items-center justify-center">
            <Spinner label="Loading resources" />
        </div>
    );
}
